import { useState, lazy, Suspense } from "react";
import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonSpinner,
} from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { IconPlus } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import "./Chats.css";

//Components
import ChatList from "../../../components/ChatList";
import {
  SearchContacts,
  ContactsBuckets,
} from "../../../components/common/contact-filters";
import { PlanUsageNavbar } from "../../../components/usage/plan";

//Stores
import { useSocketStore } from "../../../store/socket";

// Socket
import { useHistory } from "react-router";
import { useHandleNewMessage } from "../../../hooks";
import DropdownCheckbox from "../../../components/common/contact-filters/";
import { useAppStore } from "../../../store/app";
import useContactsStore from "../../../store/contacts";

const NewConversation = lazy(
  () => import("../../../components/new-conversation"),
);

const Chats = () => {
  const [isOpenNewConv, setOpenNewConv] = useState<boolean>(false);
  const history = useHistory();
  const { socketReady } = useSocketStore();
  const settings = useAppStore((state) => state.settings);

  const filters = useContactsStore((state) => state.filters);
  const isArchivedBucket = filters.find(
    (f) => f.label === "bucket" && f.value === "archived",
  )?.isActive;

  const selectChat = async (contactId: string) => {
    history.push(`/chat/${contactId}`);
  };

  useHandleNewMessage();

  return (
    <>
      <IonPage id="main-content">
        <IonHeader>
          <IonToolbar>
            <div slot="start">
              <span className="ion-right-title">
                <FormattedMessage id="nav.inbox" />
              </span>
            </div>
            <div slot="end">
              <Link to="/settings/payment" style={{ textDecoration: "none" }}>
                <PlanUsageNavbar settings={settings} isMobile={true} />
              </Link>
            </div>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen={true} className="chat-mobile-wrapper">
          <div className="chat-interface">
            {!isArchivedBucket && (
              <div className="chat-interface-nav">
                <div className="flex gap-2 align-items-center searchbar-container">
                  <SearchContacts />
                  {settings.isWaReady && (
                    <>
                      <IconPlus
                        role="button"
                        color="var(--visito-color-1)"
                        size={26}
                        onClick={() => setOpenNewConv(true)}
                      />
                      <Suspense fallback="Loading...">
                        <NewConversation
                          isOpen={isOpenNewConv}
                          onOpenChange={setOpenNewConv}
                          settings={settings}
                          id="new-conversation-mobile-modal"
                        />
                      </Suspense>
                    </>
                  )}
                  <DropdownCheckbox
                    companies={settings.companies}
                    defaultClass={""}
                  />
                </div>
              </div>
            )}

            <div className="chat-interface-nav-buckets">
              {!socketReady ? (
                <div className="connection-status fs-3 color-step-700 flex align-items-center p-2">
                  <IonSpinner
                    color="medium"
                    name="lines-sharp-small"
                  ></IonSpinner>{" "}
                  <FormattedMessage id="common.connecting" />
                </div>
              ) : (
                <>{!isArchivedBucket && <ContactsBuckets fill={true} />}</>
              )}
            </div>

            <ChatList
              mode={"mobile"}
              select={selectChat}
              isMulti={settings.multiAccount}
            />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default Chats;
